/* eslint-disable */
import { tr } from "date-fns/locale";
import { JsonAny } from "../common/Types";
import parseISO from "date-fns/parseISO";

export function isUser(roles: UserRole[] | undefined) {
  return roles?.length === 0;
}

// export function isAdmin(roles: UserRole[] | undefined) {
//   return false;
// }

// export function isPresenter(roles: UserRole[] | undefined) {
//   return false;
// }

// export function isPresenterAndAdmin(roles: UserRole[] | undefined) {
//   return true;
// }
export function isAdmin(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "ADMIN");
}

export function isPresenter(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "PRESENTER");
}

export function isPresenterAndAdmin(roles: UserRole[] | undefined) {
    return (
        !!roles?.some((role) => role.role === "PRESENTER")
        && !!roles?.some((role) => role.role === "ADMIN")
    );
}
export interface UserData extends User {
  roles: UserRole[];
  skills: UserSkill[];
  histories: WatchHistory[];
}

// 認証
export interface Auth {
  email: string;
  password: string;
}
// 認証
export interface Authn {
  email: string;
  mttms: string;
}

// ユーザーログインリクエスト
export interface UserLogin {
  email: string;
  fullName: string;
  isNew?: boolean;
  profileImageUrl: string;
  organization: string;
  localAccountId: string;
}

export interface User {
  id: string;
  email: string;
  lastLogin: Date;
  fullName: string;
  imageUrl: string;
  updated: Date;
  created: Date;
  organization: string;
  localAccountId: string;
  roles: UserRole[];
}

export type Role = "PRESENTER" | "ADMIN";
export interface UserRole {
  userId: string;
  id: string;
  role: Role;
  created: Date;
}
export interface UserItems {
  id: string;
  fullName: string;
  organization?: string;
  localAccountId?: string;
  profileImageUrl: string;
}
export interface UserSkill {
  skillId: string;
  skillName: string;
}

export interface WatchHistory {
  videoId: string;
  watchTimestamp: string;
  isFinished: boolean;
}

// ユーザー一覧取得
export interface UserList {
  id: string;
  imageUrl: string;
  fullName: string;
  email: string;
  organization: string;
  localAccountId: string;
  lastLogin: string;
  skills: string[];
  roles: string[];
}

// ユーザ一覧更新
export interface UpdateUserList {
  id: string;
  imageFile: any;
  fullName: string;
  skills: string[];
  roles: string[];
}

export function mapRolesToStrings(user: UserData) {
  const { roles } = user;
  if (!roles || roles.length === 0) {
    return "User";
  }

  return roles
    .map((role) => {
      if (role.role === "PRESENTER") {
        return "Professional";
      } else if (role.role === "ADMIN") {
        return "Admin";
      }

      return "";
    })
    .join(", ");
}

export function parseUser(json: JsonAny): User {
  return {
    ...json,
    lastLogin: parseISO(json.lastLogin),
    created: parseISO(json.created),
    updated: parseISO(json.updated),
  };
}
